import { render, staticRenderFns } from "./FoodAdd.vue?vue&type=template&id=6fce01f0&scoped=true&"
import script from "./FoodAdd.vue?vue&type=script&lang=js&"
export * from "./FoodAdd.vue?vue&type=script&lang=js&"
import style0 from "./FoodAdd.vue?vue&type=style&index=0&id=6fce01f0&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fce01f0",
  null
  
)

export default component.exports